import { combineReducers } from 'redux';
import matConListRowData from './updateMatCon';
import materialListRowData from './updateMaterial';
import workflowRowData from './updateWorkflow';
import ltdcListRowData from './updateLTDC';
import ltdcApproveRowData from './updateLtdcApproval';
import msmeListRowData from './updateMSME';
import commonRowData from './updateCommon';
import mailRedirectData from './updatemailRedirect';
import pageData from './updatePageData';
import chatNotificationData from './updateChatNotification';
const rootReducer = combineReducers({
  matConListRowData,
  materialListRowData,
  workflowRowData,
  ltdcListRowData,
  ltdcApproveRowData,
  msmeListRowData,
  commonRowData,
  mailRedirectData,
  pageData,
  chatNotificationData,
});
export default rootReducer;
